import { render, staticRenderFns } from "./AddCost.vue?vue&type=template&id=778e2faa&"
import script from "./AddCost.vue?vue&type=script&lang=js&"
export * from "./AddCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports